import React from 'react';
import { Alert } from 'react-bootstrap';
import { connect } from 'react-redux';


class alert extends React.Component {
    render() {
        if (this.props.error)
        {
            return (
                <Alert variant="danger" >
                    <Alert.Heading>{this.props.headerAlert}</Alert.Heading>
                    <p>
                        {this.props.messageAlert}
                    </p>
                </Alert>

            );
        }

        else
        return <></>;
    }
}
const mapStateToProps = (state) => {
    return {
    }
};
export default connect(mapStateToProps, {})(alert);



